// extracted by mini-css-extract-plugin
export default {"root":"formControlLabel_root__ISj7Z","label":"formControlLabel_label__9y7JD","labelStart":"formControlLabel_labelStart__nAIaM","labelEnd":"formControlLabel_labelEnd__Goo78"};